import React from "react";
import PropTypes from "prop-types";

import Item from "./Item";

const List = ({ data, onDelete, onEdit }) => (
  <div>
    {data.map(item => (
      <Item key={item.id} data={item} onDelete={onDelete} onEdit={onEdit} />
    ))}
  </div>
);

List.propTypes = {
  data: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};

export default List;
